var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgGrid = function SvgGrid(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    style: {
      enableBackground: "new 0 0 24 24"
    },
    xmlSpace: "preserve"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "grid_svg__st0",
    d: "M11 3.6V.8c0-.4-.4-.8-.8-.8H2.9C2.1 0 1.5.3 1 .7.4 1.2 0 2 0 2.9v7.4c0 .3.4.7.8.7h2.8C4 7.1 7.1 4 11 3.6zM3.6 13H.8c-.4 0-.8.4-.8.8v6.6c0 2 1.6 3.6 3.6 3.6h6.6c.4 0 .8-.4.8-.8v-2.8C7.1 20 4 16.9 3.6 13zM23.2 13h-2.8c-.5 3.9-3.5 7-7.4 7.4v2.8c0 .4.4.8.8.8h6.6c2 0 3.6-1.6 3.6-3.6v-6.6c0-.4-.4-.8-.8-.8zM20.4 0h-6.6c-.4 0-.8.4-.8.8v2.8c3.9.5 7 3.5 7.4 7.4h2.8c.4 0 .8-.4.8-.8V3.6c0-2-1.6-3.6-3.6-3.6zM14.1 6.7c-.6-.6-1.3-.8-2.1-.8-.9 0-1.6.3-2.1.8-.6.5-.9 1.2-.9 2.1s.3 1.6.8 2.1c.6.6 1.3.8 2.1.8.9 0 1.6-.3 2.1-.8.6-.6.8-1.3.8-2.1s-.1-1.6-.7-2.1z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "grid_svg__st0",
    d: "M12 18.9c2.6 0 4.9-1.5 6.1-3.7 0-.1-.1-.2-.1-.2-.3-.4-.6-.6-1-.8-.9-.4-1.7-.7-2.5-.9-.9-.2-1.7-.3-2.5-.3s-1.6.1-2.4.3c-.8.2-1.7.5-2.5.9-.4.2-.7.5-1 .8-.1.1-.1.1-.1.2 1.1 2.2 3.4 3.7 6 3.7z"
  })));
};
export default SvgGrid;